import { AttendanceStatus } from "@/types/attendanceStatus"
import { icon_absent, icon_late, icon_present, icon_questionMarkCircle } from "./svgIcons"
import { JustificationValidationStatus } from "@/entities/attendanceEvent/AttendanceEventType"
import { format, isSameDay } from "date-fns"
import { fr } from "date-fns/locale"
import clsx from "clsx"

export function getTypeIcon(type: AttendanceStatus) {
   if (type === "present") {
      return icon_present
   } else if (type === "absent") {
      return icon_absent
   } else if (type === "late") {
      return icon_late
   } else {
      return icon_questionMarkCircle
   }
}

const typeTranslation = {
   present: "Présent",
   absent: "Absence",
   late: "Retard",
   external: "Extérieur",
}

export function getTypeTitle(type: keyof typeof typeTranslation) {
   return typeTranslation[type]
}

export function getStatusBadge(
   justified: boolean,
   status: JustificationValidationStatus,
   isFull?: boolean,
) {
   let label = "???"
   let badgeClass = "badge-error"

   if (justified) {
      label = "Validé"
      badgeClass = "badge-success"
   } else {
      switch (status) {
         case "upload_pending":
            label = "À justifier"
            badgeClass = "badge-warning"
            break
         case "admin_pending":
            label = "En attente"
            badgeClass = "badge-info"
            break
         case "validated":
            label = "Validé"
            badgeClass = "badge-success"
            break
         case "rejected":
            label = "Refusé, à justifier"
            badgeClass = "badge-error"
            break
      }
   }

   return <span className={clsx("badge", badgeClass, isFull && "badge-lg")}>{label}</span>
}

export function formatDateRange(from: Date, to: Date, type: string) {
   const timeFormat = "HH:mm"

   if (type === "late") {
      return `${format(from, "d MMMM   ", { locale: fr })} ${format(from, timeFormat)}`
   }

   if (isSameDay(from, to)) {
      return `${format(from, "d MMMM   ", { locale: fr })} ${format(from, timeFormat)} → ${format(
         to,
         timeFormat,
      )}`
   }
   return `${format(from, "d MMMM    HH:mm", { locale: fr })} → ${format(to, "d MMMM    HH:mm", {
      locale: fr,
   })}`
}
